import type { ReactNode } from 'react';

import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';

import type { BulkPrivacyChange } from './hooks/useGalleryManageMode';
import type { GalleryItem, PaginationConfig } from './ImageGallery.common';
import ImageGridCloseButton from './ImageGridCloseButton';
import ManagedGalleryGrid from './ManagedGalleryGrid';

type ImageGridProps = {
  images: GalleryItem[] | undefined;
  onClose: () => void;
  onImageClick: (index: number) => void;
  pagination?: PaginationConfig;
  renderImageOverlay?: (index: number) => ReactNode;
  /** Native only. See `ImageGridContainer.native`. */
  virtualizedGrid?: boolean;
  dimmedImageIds?: Set<number>;
  lockedImageIds?: Set<number>;
  isViewingOwnGallery?: boolean;
  onBulkPrivacyChange?: BulkPrivacyChange;
  gridHeader?: ReactNode;
};

const ImageGrid = ({
  images,
  onClose,
  onImageClick,
  pagination,
  renderImageOverlay,
  virtualizedGrid,
  dimmedImageIds,
  lockedImageIds,
  isViewingOwnGallery,
  onBulkPrivacyChange,
  gridHeader,
}: ImageGridProps): JSX.Element => (
  <ManagedGalleryGrid
    contrast
    images={images}
    onImageClick={onImageClick}
    onClose={onClose}
    pagination={pagination}
    renderImageOverlay={renderImageOverlay}
    virtualizedGrid={virtualizedGrid}
    dimmedImageIds={dimmedImageIds}
    lockedImageIds={lockedImageIds}
    isViewingOwnGallery={isViewingOwnGallery}
    onBulkPrivacyChange={onBulkPrivacyChange}
    gridHeader={gridHeader}
    headerEnd={!isReactNative() ? <ImageGridCloseButton onClick={onClose} /> : undefined}
  />
);

export default ImageGrid;
